import { loadStripe } from '@stripe/stripe-js';

let stripePromise = null;

const getPublishableKey = () => process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

const initStripe = (forceReload = false) => {
  if (forceReload) {
    stripePromise = null;
  }

  if (stripePromise) {
    return stripePromise;
  }

  const publishableKey = getPublishableKey();

  if (!publishableKey) {
    console.error('[Stripe] Missing REACT_APP_STRIPE_PUBLISHABLE_KEY');
    return Promise.resolve(null);
  }

  stripePromise = loadStripe(publishableKey)
    .then((stripe) => {
      if (!stripe) {
        console.error('[Stripe] Stripe.js loaded but Stripe instance is null');
      }
      return stripe;
    })
    .catch((error) => {
      console.error('[Stripe] Failed to load Stripe.js:', error);
      stripePromise = null;
      return null;
    });

  return stripePromise;
};

export const getStripePromise = () => initStripe(false);
export const reloadStripePromise = () => initStripe(true);
